import cx from 'classnames';
import AffordableCarsGraphic from './AffordableCarsGraphic';
import styles from './AffordableCarsShaqGraphic.module.css';

export default function AffordableCarsShaqGraphic() {
  return (
    <div
      className={cx(
        'absolute left-[32px] top-[116px] w-[252px] overflow-hidden',
        styles.sign
      )}
      data-testid="affordable-cars-shaq-graphic"
    >
      <AffordableCarsGraphic overlayColor="white" overlayPosition="bottom" />
    </div>
  );
}
